import { animate, style, transition, trigger } from '@angular/animations';
import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, EventEmitter, HostListener, Input, Output, Renderer2, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { FileExport } from './file-export.interface';
import { ViewPorts } from './viewports';
import { vp } from './vp.interface';
import { BrowserWindow } from './window';
declare var $: any;

@Component({
    selector: 'ups-export-file',
    template: require('./ups-export-file.component.html'),
    providers: [BrowserWindow, ViewPorts],
    animations: [
        trigger('fadeInOut', [
            transition('void => *', [
                style({ opacity: 0 }),
                animate(200, style({ opacity: 1 }))
            ]),
            transition('* => void', [
                animate(200, style({ opacity: 0 }))
            ])
        ])

    ]
})

export class UpsExportFileComponent implements AfterViewInit {
    globalClick: Function;
    globalKeydown: Function;
    closeFocusElm: HTMLElement;
    toggleMenuShown: boolean = false;
    vpSize: vp;
    public fileExport: FileExport = { EmailDownloadValue: 1, email: '', excelFormat: 'CSV' };
    focusedItemIndex: number = -1;
    focusableIndexes = [];
    @ViewChild('toggleDrawerContainer', { static: false }) toggleDrawerContainer: ElementRef;
    @ViewChild('exportFileCSV', { static: false }) exportFileCSV: ElementRef;


    registerForm: FormGroup;
    submitted = false;
    get formExportFile() { return this.registerForm.controls; }
    @Input() public isLoadding: boolean = false;
    @Input() public modalActive: boolean = false;
    public validateSizeMax: boolean = false;
    @Output() private actionSendMailOrDownload: EventEmitter<FileExport> = new EventEmitter();
    @Output() private actionClickOut: EventEmitter<boolean> = new EventEmitter();


    constructor(private renderer: Renderer2, private vp: ViewPorts, private cdRef: ChangeDetectorRef, private eRef: ElementRef, private formBuilder: FormBuilder) {
        vp.viewPortChange().subscribe((val) => {
            this.vpSize = val;
        });

    }

    ngAfterViewInit(): void {
        this.registerForm = this.formBuilder.group({
            exportFileFormat: new FormControl(''),
            chooseEmailOrDownload: new FormControl(1),
            trkResultsExportEmail: ['', [Validators.required, Validators.pattern(/^[_a-z0-9]+(\.[_a-z0-9]+)*@[a-z0-9-]+(\.[a-z0-9-]+)*(\.[a-z]{2,4})$/)]]

        });

        if (this.toggleDrawerContainer) {
            var tvDrawerContainer = $(this.toggleDrawerContainer.nativeElement).detach();
            $('body').prepend(tvDrawerContainer);
            this.cdRef.detectChanges();
        }
    }

    public validationDownloadSize(value: boolean) {
        this.validateSizeMax = value;
    }

    public onSubmitExport(): void {
        if (this.fileExport.EmailDownloadValue === 1) {
            if (this.registerForm.invalid) {
                this.submitted = true;
                return;
            }
            this.actionSendMailOrDownload.emit(this.fileExport);
        } else {

            this.actionSendMailOrDownload.emit(this.fileExport);
        }
    }

    public onSelectionChange(fileExport: FileExport, val: number): void {
        fileExport.EmailDownloadValue = val;
        fileExport.email = '';
        this.validateSizeMax = false;
    }

    public show(el: HTMLElement): void {

        if (!el) {
            console.error('Error when opening toggle view: Toggle View requires an element to attach to.');
            return;
        }

        if (this.toggleMenuShown) {
            this.hide();
            return;
        }

        this.toggleMenuShown = true;
        this.closeFocusElm = el;
    }

    public hide(): void {
        this.registerForm.reset();
        this.toggleMenuShown = false;
        this.fileExport.email = '';
        this.fileExport.EmailDownloadValue = 1;
        this.submitted = false;
        this.validateSizeMax = false;
        if (this.exportFileCSV) {
            this.exportFileCSV.nativeElement.click();
        }
        var wasOpen: boolean = this.toggleMenuShown;

        if (wasOpen) {
            this.closeFocusElm.focus();
        }
    }

    @HostListener('document:click', ['$event'])
    clickout(e) {
        if (!this.eRef.nativeElement.contains(e.target)) {
            if (!this.closeFocusElm) {
                return;
            }
            if (e.target == this.closeFocusElm || $.contains(this.closeFocusElm, e.target)) {
                return;
            }
            //
            if (!this.modalActive) {
                this.hide();
            }
            this.actionClickOut.emit(true);
        }

    }

    public calculateArrowLeft(): string {
        var focusElWidth: number = $(this.closeFocusElm).outerWidth();
        var focusElLeft: number = $(this.closeFocusElm).offset().left;

        switch (true) {
            case this.vpSize.isLGVP:
                return (focusElLeft - ((focusElWidth / 2) + 80)).toString() + 'px';
                break;
            case this.vpSize.isMDVP:
                return (focusElLeft - ((focusElWidth / 2) + 20)).toString() + 'px';
                break;
            case this.vpSize.isSMVP:
                return (focusElLeft - ((focusElWidth / 2) + 30)).toString() + 'px';
                break;
            case this.vpSize.isXSVP:
                return (focusElLeft - (focusElWidth / 2)).toString() + 'px';
                break;
            default:
                return (focusElLeft - ((focusElWidth / 2) + 80)).toString() + 'px';
                break;
        }
        return (focusElLeft - ((focusElWidth / 2) + 80)).toString() + 'px';

    }

    public validateClass(valueSubmitted: boolean, valueErrors: any): string {
        let classStyles: string = ''
        if (valueSubmitted) {
            if (valueErrors) {
                classStyles = 'ups-form_input ng-pristine ng-invalid ups-bodError ng-touched';
            } else {
                classStyles = 'ups-form_input ng-dirty ng-touched ng-valid';
            }

        } else {
            classStyles = 'ups-form_input ng-dirty ng-touched ng-valid';
        }
        return classStyles;
    }

    public cancel(): void {
        this.actionClickOut.emit(true);
        this.hide();
    }

    toggleDrawerContainerClick(e: Event) {
        e.stopPropagation();
    }

    focusInput(item: any) {
        document.getElementById(item).focus();
    }
}